import { Scaffold } from 'layouts';
import { ListRejectedOrders } from 'components/Pages/Scheduling/PaginatedRejectedOrders';
import { SchedulingLayout } from 'layouts/Scheduling';

export const ListRejectedOrdersPage: React.FC = () => {
  return (
    <Scaffold>
      <SchedulingLayout>
        <ListRejectedOrders />
      </SchedulingLayout>
    </Scaffold>
  );
};
